import { Component } from '@angular/core';

@Component({
  selector: 'lib-calendar',
  imports: [],
  templateUrl: './calendar.html',
})
export class CalendarIcon {}
